// this is separate file to allow easier testing
/**
 * Needed version of the library. Matches the one in package.json
 */
export const REQUIRED_VERSION = '1.6.x';
